import { render, staticRenderFns } from "./class-student-state.vue?vue&type=template&id=de5dc514&scoped=true"
import script from "./class-student-state.vue?vue&type=script&lang=js"
export * from "./class-student-state.vue?vue&type=script&lang=js"
import style0 from "./class-student-state.vue?vue&type=style&index=0&id=de5dc514&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5dc514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de5dc514')) {
      api.createRecord('de5dc514', component.options)
    } else {
      api.reload('de5dc514', component.options)
    }
    module.hot.accept("./class-student-state.vue?vue&type=template&id=de5dc514&scoped=true", function () {
      api.rerender('de5dc514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/class-student-state.vue"
export default component.exports